import { styled } from "styled-components";

export const CategoryContainer = styled.div`
  width: 100%;
  max-width: 834px; // 가운데 정렬할 땐 빼버리기
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;
